import React, { useEffect, useRef } from 'react';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import SlideImageTall from './SlideImageTall';

const CarouselImage = ({ slides }) => {
    const swiperRef = useRef(null);
    const theme = useTheme();

    useEffect(() => {
        const handleSlideChange = () => {
            if (swiperRef.current && swiperRef.current.swiper) {
                const activeSlide = swiperRef.current.swiper.slides?.[swiperRef.current.swiper.activeIndex];
                if (activeSlide) {
                    activeSlide.classList.add('zoom-in');
                    setTimeout(() => {
                        activeSlide.classList.remove('zoom-in');
                    }, 3000); // Zoom effect lasts 3 second
                }
            }
        };

        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.on('slideChange', handleSlideChange);
        }

        return () => {
            // Ensure swiperRef exists before calling .off()
            if (swiperRef.current && swiperRef.current.swiper) {
                swiperRef.current.swiper.off('slideChange', handleSlideChange);
            }
        };
    }, []);

    return (
        <Swiper
            ref={swiperRef}
            spaceBetween={0}
            slidesPerView={1}
            // navigation={{
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // }}
            // navigation
            pagination={{ clickable: true, el: '.swiper-pagination-bullet' }}
            autoplay={{ delay: 3000, disableOnInteraction: false }} // Auto-slide every 3 seconds
            speed={700}
            loop={true}
            simulateTouch={true}
            modules={[ Pagination, Autoplay]} // Added Autoplay            
        // style={{ backgroundColor: 'white' }}
        >
            {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                    <SlideImageTall backgroundImage={slide.background} />
                </SwiperSlide>
            ))}

            {/* Inline arrow styles */}
            {/* <Box
                    className="swiper-button-next"
                    sx={{
                        color: theme.palette.secondary.main,
                        '&:hover': { color: theme.palette.secondary.dark },
                    }}
                />
                <Box
                    className="swiper-button-prev"
                    sx={{
                        color: theme.palette.secondary.main,
                        '&:hover': { color: theme.palette.secondary.dark },
                    }}
                /> */}

            {/* Inline dot styles */}
            {/* <Box            
                className="swiper-pagination-bullet"
                sx={{
                    '& .swiper-pagination-bullet': {
                        backgroundColor: theme.palette.secondary.main,
                    },
                }}
            /> */}
        </Swiper>
    );
};

export default CarouselImage;
